module.exports = __webpack_public_path__ + "static/media/spinach3.f15d83e6.png";